<template>
  <div :class="['custom-dropdown relative', {'focus': showOption, 'selected': selected}]" :tabindex="tabindex">
    <div class="custom-select bd-1 bd-gray-medium h-44 pl-16 pr-16 flex items-center hand" :class="round ? 'br-14' : 'br-12'" @click="selectboxOpen">
      <div class="display-text bd-n wp-100 fs-14 lh-17 outline-0 hand flex items-center mr-12 arial">
        <slot name='text'></slot>
        <slot name='select'></slot>
      </div>
      <slot name='clearSelection'></slot>
      <template v-if="type === 'text' || type === 'ratings'">
        <template v-if="!hideArrow">
          <template v-if='showOption'>
            <svg width='8' height='6' viewBox='0 0 8 6' fill='none' xmlns='http://www.w3.org/2000/svg'>
              <path fill-rule='evenodd' clip-rule='evenodd'
                    d='M4 0.333313L0 4.33331L0.94 5.27331L4 2.21998L7.06 5.27331L8 4.33331L4 0.333313Z' fill='#000' />
            </svg>
          </template>
          <template v-else>
            <svg width='8' height='6' viewBox='0 0 8 6' fill='none' xmlns='http://www.w3.org/2000/svg'>
              <path fill-rule='evenodd' clip-rule='evenodd'
                    d='M4 5.27332L8 1.27332L7.06 0.333315L4 3.38665L0.94 0.333315L3.49691e-07 1.27331L4 5.27332Z'
                    fill='#000' />
            </svg>
          </template>
        </template>
      </template>
    </div>
    <div v-if='showOption && $slots["select-option"]'
      :class="round ? 'br-14' : 'br-12'" class='custom-option absolute top-44 bd-1 bd-gray-medium bg-white maxh-280 overflow-auto pt-8 pb-8 wp-100 mt-8 z-997 arial'
      ref='customSelectOptions'
      >
      <slot name='select-option'></slot>
    </div>
  </div>
</template>

<script>
import { ref, watch } from 'vue'

export default {
  name: 'SelectboxBase',

  props: {
    text: {
      type: String,
      default: ''
    },
    query: {
      type: Object,
      default: null
    },
    type: {
      type: String,
      default: 'text'
    },
    show: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Boolean,
      default: false
    },
    tabindex: {
      type: Number,
      default: 0,
    },
    round: {
      type: Boolean,
      default: false
    },
    hideArrow: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:show'],
  setup(props, { emit }) {
    const showOption = ref(false)
    const customSelectOptions = ref(null)
    const lastQuery = ref({})

    const selectboxOpen = () => {
      if(props.type === 'autocomplete_search') {
        showOption.value = props.show
      } else {
        showOption.value = !showOption.value
      }
      emit('update:show', showOption.value)
    }

    watch(
      () => props.show,
      (show) => {
        showOption.value = show;
      }
    );

    watch(
      () => props.query,
      (query) => {
        if (customSelectOptions.value) {
          if (! (query.text && query.text.trim())) {
            lastQuery.value = { text:null, items:[] }
            customSelectOptions.value.scrollTop = 0
          } else if (lastQuery.value.text === query.text) {
            let length = lastQuery.value.items.length
            let index = (lastQuery.value.index + 1) % length
            let top = length ? lastQuery.value.items[index].top : 0
            let __top = parseFloat(customSelectOptions.value.scrollTop)

            customSelectOptions.value.scrollTop = top

            if (__top && (__top === parseFloat(customSelectOptions.value.scrollTop))) {
              let t = lastQuery.value.items.length ? lastQuery.value.items[0].top : 0
              //console.log(__top, customSelectOptions.value.scrollTop)
              customSelectOptions.value.scrollTop = t
              index = 0
            }

            lastQuery.value.index = index

          } else {
            let s = ('' + query.text).toLowerCase()
            let node = customSelectOptions.value.querySelector('.custom-option-item')
            let items = [];
            let top = 0;

            while (node) {
              let text = ('' + node.innerText).toLowerCase()

              if (0 <= text.search(s)) {
                items.push({
                  top: top - 5,
                  el: node
                })
              }

              top += node.offsetHeight
              node = node.nextSibling
            }

            let t = items.length ? items[0].top : 0
            customSelectOptions.value.scrollTop = t
            lastQuery.value.text = query.text
            lastQuery.value.items = items
            lastQuery.value.index = 0
          }
        }
      }
    );

    return {
      showOption,
      selectboxOpen,
      customSelectOptions
    }
  }
}
</script>

<style lang='scss' scoped>

</style>
